
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();

    $(window).scroll(function() {
        if ($(document).scrollTop() > 100) {
            $('.navbar').addClass('shrink');
            $('.navbar-logo').addClass('logosmall');
            $('.search-item').removeClass('d-none')
        } else {
            $('.navbar').removeClass('shrink');
            $('.navbar-logo').removeClass('logosmall');
            $('.search-item').addClass('d-none')
        }
      });

    jarallaxVideo();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    var swiper = new Swiper(".carousel", {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: 4000
        },
        speed: 2000,
        effect: "fade",
        fadeEffect: {
            crossFade:true
        }
    });

    var sponsorsSwiper = new Swiper(".sponsors-wrapper", {
        loop: true,
        autoplay: {
            delay: 5000
        }
    });

    $('.hail-swiper').each(function() {
        var attrs = $(this).data();
        let selector = "#HailList"+attrs['list'];
        var hailSwiper = new Swiper(selector, {
            loop: true,
            navigation: {
                nextEl: '.right-'+attrs['list'],
                prevEl: '.left-'+attrs['list']
            },
            slidesPerView: attrs['smToshow'],
            breakpoints: {
                [attrs['smBreak']]: {
                    slidesPerView: attrs['mdToshow'],
                },
                [attrs['mdBreak']]: {
                    slidesPerView: attrs['lgToshow'],
                },
            },
            spaceBetween: 20
        });
    });

    if($('.pagination-wrapper').length > 0) {
        HailPaginationDisplay();
    }
});

function HailPaginationDisplay(){
    //resize just happened, pixels changed
    $('.pagination-source').css('display','none');
    var totalListItems = 0;
    var pageNum = 1;
    var visibleItems = 10;
    $('.pagination li').each(function(e){
        var el = $(this);
        var hasTitle = el.find('a').attr('title');
        if(hasTitle === undefined || hasTitle === null){
            totalListItems++;
        }
        if(el.hasClass('active')){
            pageNum = el.find('a').text();
        }
    });

    var myWidth = $(window).width();

    if(myWidth > 600 ){
        visibleItems = 10;
    } else if(myWidth > 375 && myWidth < 599){
        visibleItems = 5;
    } else {
        visibleItems = 3;
    }
    $('.pagination-wrapper').bootpag({
        total: totalListItems - 4,
        page: pageNum,
        maxVisible: visibleItems,
        leaps: true,
        firstLastUse: true,
        first: '<i class="fa fa-angle-double-left"></i>',
        last: '<i class="fa fa-angle-double-right"></i>',
        prev: '<i class="fa fa-angle-left"></i>',
        next: '<i class="fa fa-angle-right"></i>',
        wrapClass: 'pagination',
        activeClass: 'active',
        disabledClass: 'disabled',
        nextClass: 'next',
        prevClass: 'prev',
        lastClass: 'last',
        firstClass: 'first'
    }).on("page", function(event, num){
        document.location.href=$('.pagination-source li a.source-page-'+num)[0].href;
    });
    var visibleCount = 0;
    $('.pagination.bootpag li').each(function(e){
        if($(this).css("display") !== 'none'){
            visibleCount++;
        }
    });
    var paginationLength = visibleCount*43;

    $('.pagination.bootpag').css('width',paginationLength - 40);

    $(".pagination-wrapper").append("<div class='pagination-page-number'><div>Page "+pageNum+" of "+totalListItems+"</div></div>");
}
